module.exports = __webpack_public_path__ + "img/colorful-separator-2.b2cca648.svg";